import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface HasWorkBeenCompletedProps {
    value: boolean | undefined;
    onChange: (value: boolean) => void;
    required?: boolean;
    isReview?: boolean;
}

export const HasWorkBeenCompleted: React.FC<HasWorkBeenCompletedProps> = ({
    value,
    onChange,
    required = false,
    isReview = false,
}) => {
    const label = 'Has work been completed?';

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                onChange(true);
                return;
            case 'no':
                onChange(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={value ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonHasWorkBeenCompleted'
                    value={value}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This field is required.'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
